import React from 'react'
import { InputGroup } from 'react-bootstrap'
import Field from '../Field'
import parsePercentage from '../../utils/parsers/parsePercentage'

const formatValue = (value) => value == null ? '' : value
const parseValue = (value) => {
  const newValue = value == null ? null : parsePercentage(value)
  return newValue == null || newValue === '' ? null : newValue
}

function PercentageField({ ...inputProps }) {
  return (
    <Field
      format={formatValue}
      parse={parseValue}
      inputGroupAfter={<InputGroup.Addon>%</InputGroup.Addon>}
      {...inputProps}
    />
  )
}

export default PercentageField



// WEBPACK FOOTER //
// ./src/components/PercentageField/index.js